import React from 'react';
import PropTypes from 'prop-types';
import { Form as FormikForm } from 'formik';
import TextField from '../../../../web-app-components/components/TextField';
import ButtonPrimary from '../../../../web-app-components/components/ButtonPrimary';
import makeStyles from '@material-ui/core/styles/makeStyles';

import LocationField from './components/LocationField';
import CategoriesSelectField from './components/CategoriesSelectField';
import FilesField from './components/FilesField';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > :not(:last-child)': {
      marginBottom: theme.spacing(2),
    },
  },
}));

const fieldIsEmpty = (values, key) => {
  const value = values?.[key]
  if (typeof value === 'string' || Array.isArray(value)) {
    return value.length === 0;
  }
  if(typeof value === 'object'){   
    return value === null
  }
  return typeof value !== 'number';
};


const Form = ({ isSubmitting, suggested, values }) => {
  const classes = useStyles();

  return (
    <FormikForm>
      <div className={classes.root}>
        {(!suggested || !fieldIsEmpty(values, 'Coordinates')) && <LocationField name="Coordinates" />}
        {(!suggested || !fieldIsEmpty(values, 'Title')) && <TextField name="Title" label="Pavadinimas" fullWidth />}
        {(!suggested || !fieldIsEmpty(values, 'Description')) && <TextField
          name="Description"
          label="Aprašymas"
          multiline
          rows={4}
          fullWidth
        />}
        {(!suggested || !fieldIsEmpty(values, 'Pictures')) && <FilesField
          name="Pictures"
          accept="image/*"
          label="Nuotraukos"
          disabled={isSubmitting}
        />}
        {(!suggested || !fieldIsEmpty(values, 'AudioRecordings')) && <FilesField
          name="AudioRecordings"
          accept="audio/*"
          label="Garso įrašai"
          disabled={isSubmitting}
        />}
        {(!suggested || !fieldIsEmpty(values, 'categories')) && <CategoriesSelectField
          name="categories"
          label="Kategorijos"
          fullWidth
        />}
        {(!suggested || !fieldIsEmpty(values, 'VideoURL')) && <TextField name="VideoURL" label="Video nuoroda" fullWidth />}
        {(!suggested || !fieldIsEmpty(values, 'WebsiteURL')) && <TextField name="WebsiteURL" label="Internetinė svetainė" fullWidth />}
        {(!suggested || !fieldIsEmpty(values, 'PhoneNumber_1')) && <TextField name="PhoneNumber_1" label="Telefono numeris (1)" fullWidth />}
        {(!suggested || !fieldIsEmpty(values, 'PhoneNumber_2')) && <TextField name="PhoneNumber_2" label="Telefono numeris (2)" fullWidth />}
        <ButtonPrimary type="submit" disabled={isSubmitting}>
          {suggested ? 'Patvirtinti' : 'Išsaugoti'}
        </ButtonPrimary>
      </div>
    </FormikForm>
  );
};

Form.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
};

export default Form;
